/**
 * WideScreenshotCard — iter87.514 (+ iter87.516 sizeBy variant)
 *
 * Variant of `PhoneFrame` for Pro+ screenshots that don't fit the tall
 * phone bezel. Default mode (`sizeBy="width"`) is for the 2 genuinely
 * wide hub captures (~1320x1496) — width-driven, height follows.
 *
 * `sizeBy="height"` flips this: the card is HEIGHT-driven to match
 * the other cards' rendered height exactly (same width formula, just
 * solved the other way), while `aspect` sets the real image's native
 * ratio so the full screenshot shows uncropped — narrower, not wider.
 * Used for the Rivalries Intel slide so "Bot Says" (lower on that
 * tall capture) isn't cropped off by a top-anchored `object-cover`.
 */
import React from "react";

const CARD_WIDTH = "clamp(260px, 78vw, 340px)";
const CARD_HEIGHT = "calc(clamp(260px, 78vw, 340px) * 1496 / 1320)";
export { CARD_WIDTH, CARD_HEIGHT };

export default function WideScreenshotCard({
    children, tone = "blaze", label, aspect = "1320 / 1496", sizeBy = "width",
}) {
    const glow =
        tone === "volt"  ? "shadow-brutalBlue"
        : tone === "heat"  ? "shadow-brutalRed"
        : tone === "blaze" ? "shadow-brutalOrange"
        : tone === "neon"  ? "shadow-brutalGreen"
        : "shadow-brutalYellow";

    const sizeStyle = sizeBy === "height"
        ? { height: CARD_HEIGHT, aspectRatio: aspect }
        : { width: CARD_WIDTH, aspectRatio: aspect };

    return (
        <div
            data-testid={label ? `wide-screenshot-${label}` : "wide-screenshot"}
            className={`relative shrink-0 snap-center select-none rounded-[28px] border-[3px] border-zinc-800 bg-[#0a0a0a] overflow-hidden ${glow}`}
            style={sizeStyle}
        >
            <div className="absolute inset-[6px] rounded-[22px] overflow-hidden bg-[#0A0A0A]">
                {children}
            </div>
        </div>
    );
}

